/**
 * Enum representing a summarized shipment status
 */
export enum SummarizedShipmentStatus {
  Unknown = 'Unknown',
  EnRouteToIcelandPost = 'EnRouteToIcelandPost',
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  Completed = 'Completed',
}

/**
 * NOTE: This function needs to match the logic defined on the backend.
 * @see mobiz-posturinn-extension:Posturinn.Extension.Service.Postal.Services.OrganizationPostalService.GetShipments()
 */
export function shipmentIsActive(status: SummarizedShipmentStatus): boolean {
  return status !== SummarizedShipmentStatus.Completed;
}
